import React from 'react'
import { Dialog, Stack } from '@mui/material'
import { FullScreenActionDialogProps } from './_props'
import sxs from './_sxs'
import Callout from '../callout/Callout'
import FullScreenActionDialogHeader from './FullScreenActionDialogHeader'
import Loader from '../Loader/Loader'
import { FullScreenActionDialogContextProvider } from './context/FullScreenActionDialogContext'

const FullScreenActionDialog: React.FC<FullScreenActionDialogProps> = ({
    children,
    open,
    callout,
    title,
    innerContainerVariant = 'contained',
    isLoading,
    loadingMessage,
    ...props
}) => (
    <Dialog open={open} fullScreen>
        <FullScreenActionDialogContextProvider initialValues={props}>
            <Stack
                alignItems="center"
                sx={[
                    sxs.fullscreenActionDialog,
                    innerContainerVariant === 'fullscreen' && {
                        padding: `3.5rem 0 0 0 !important`,
                    },
                ]}
            >
                <FullScreenActionDialogHeader title={title} innerContainerVariant={innerContainerVariant} />
                <Stack gap="1.5rem" sx={sxs.fullScreenActionDialogMainContainer}>
                    {callout && (
                        <Stack flexDirection="row">
                            <Callout
                                icon={callout.icon}
                                color={callout.color}
                                backgroundColor={callout.backgroundColor}
                            >
                                {callout.children}
                            </Callout>
                        </Stack>
                    )}
                    <Stack flexDirection="row" alignItems="center" sx={sxs.fullScreenActionDialogInnerContainer}>
                        {isLoading ? (
                            <Stack flexDirection="row" alignItems="center" justifyContent="center" minHeight="60vh">
                                <Loader title={loadingMessage} progressSize="2.5rem" />
                            </Stack>
                        ) : (
                            children
                        )}
                    </Stack>
                </Stack>
            </Stack>
        </FullScreenActionDialogContextProvider>
    </Dialog>
)

export default FullScreenActionDialog
